import React, { FC, useContext } from 'react';
import cx from 'classnames';
import Button from '@zola/zola-ui/src/components/Button/ButtonV2';
import signupLinkCallback from 'components/common/auth/AuthModal/helpers/signupLinkCallback';

import './navLoginOrSignUp.less';
import {
  CtaType,
  trackCtaClicked,
} from '@zola-helpers/client/dist/es/tracking/ctaEvents/ctaEvents';
import type { NavLoginOrSignUpDispatchProps } from '.';
import NavContext from '../NavScrollContainer/context';

type NavLoginOrSignUpProps = NavLoginOrSignUpDispatchProps & {
  isNavV3?: boolean;
};

const NavLoginOrSignUp: FC<NavLoginOrSignUpProps> = ({ onShowLogin, isNavV3 = false }) => {
  const { activeLinkId } = useContext(NavContext);
  const onHomepage = window.location.pathname === '/';

  const handleClickTrack = () => {
    const homepageText = 'Start Your Free Registry';
    const ctaText = onHomepage ? homepageText : 'Sign Up';
    trackCtaClicked({
      business_unit: 'CORE',
      cta_type: CtaType.BUTTON,
      cta_id: 'NAV_PRE_AUTH_SIGNUP',
      position: 1,
      cta: ctaText,
    });
    if (signupLinkCallback(activeLinkId)) onShowLogin();
  };

  return (
    <>
      {onHomepage && !isNavV3 ? (
        <Button
          component="a"
          href="/onboard/new"
          className={cx('nav-signup', 'nav-signup--promo-box')}
          compact
          onClick={handleClickTrack}
          textTransform={false}
        >
          <div className="promo-box__title">Start your</div>
          <div className="promo-box__subtitle">free registry</div>
        </Button>
      ) : (
        <Button compact={!isNavV3} className="nav-signup" onClick={handleClickTrack}>
          {isNavV3 ? 'Get started' : 'Sign Up'}
        </Button>
      )}
    </>
  );
};

export default NavLoginOrSignUp;
